export default "https://assets.egbcdn.net/assets/packs/_/images/bookmaker-stamp-7999692e335d18f6e84ac159060d3da9.png";